import especialidade from '@/repositories/conecta-sus/cadastro/especialidadeRepository'
import estabelecimento from '@/repositories/conecta-sus/cadastro/estabelecimento/index'
import fabricante from '@/repositories/conecta-sus/cadastro/fabricante/fabricanteRepository'
import feriado from '@/repositories/conecta-sus/cadastro/feriado/index'
import fornecedor from '@/repositories/conecta-sus/cadastro/fornecedor/fornecedorRepository'
import grupo from '@/repositories/conecta-sus/cadastro/grupo/grupoRepository'
import localizacao from '@/repositories/conecta-sus/cadastro/localizacao/index'
import material from '@/repositories/conecta-sus/cadastro/material/materialRepository'
import materialBnafar from '@/repositories/conecta-sus/cadastro/materialBnafarRepository'
import medicamento from '@/repositories/conecta-sus/cadastro/medicamento/index'
import medicamentoNaoPadronizado from '@/repositories/conecta-sus/cadastro/medicamentoNaoPadronizadoRepository'
import obito from '@/repositories/conecta-sus/cadastro/obitoRepository'
import subgrupo from '@/repositories/conecta-sus/cadastro/subgrupo/subgrupoRepository'
import sujeitoAtencao from '@/repositories/conecta-sus/cadastro/sujeito-atencao/index'
import unificaCidadao from '@/repositories/conecta-sus/cadastro/unificaCidadaoRepository'
import usuarioPerfil from '@/repositories/conecta-sus/cadastro/usuarioPerfilRepository'
import vacina from '@/repositories/conecta-sus/cadastro/vacinaRepository'
import parametrizacao from '@/repositories/conecta-sus/cadastro/parametrizacao/parametrizacaoRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/cadastro`

    return {
        especialidade: especialidade(baseUrl),
        estabelecimento: estabelecimento(baseUrl),
        fabricante: fabricante(baseUrl),
        feriado: feriado(baseUrl),
        fornecedor: fornecedor(baseUrl),
        grupo: grupo(baseUrl),
        localizacao: localizacao(baseUrl),
        material: material(baseUrl),
        materialBnafar: materialBnafar(baseUrl),
        medicamento: medicamento(baseUrl),
        medicamentoNaoPadronizado: medicamentoNaoPadronizado(baseUrl),
        obito: obito(baseUrl),
        subgrupo: subgrupo(baseUrl),
        sujeitoAtencao: sujeitoAtencao(baseUrl),
        unificaCidadao: unificaCidadao(baseUrl),
        usuarioPerfil: usuarioPerfil(baseUrl),
        vacina: vacina(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
    }
}